(() => {
  'use strict';
  if (customElements.get('armadox-boot-story')) return;
  class ArmadoxBootStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const product = [...document.querySelectorAll('product-info[data-section-type="product-page"]')].find(el => el.dataset.productId === this.dataset.productId);
      if (!product) return;
      try { this.variants = JSON.parse(this.querySelector('[data-boot-story-variants]').textContent); } catch { return; }
      this.panels = [...this.querySelectorAll('[data-boot-story-color]')];
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      product.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.render(event.target.value);
      }, options);
      document.addEventListener('variant:changed', event => {
        const id = event.detail?.variant?.id;
        if (id && String(product.querySelector('product-form input[name="id"]')?.value) === String(id)) this.render(id);
      }, options);
      this.render(product.querySelector('product-form input[name="id"]')?.value || this.dataset.selectedId);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    render(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      for (const panel of this.panels) panel.hidden = panel.dataset.bootStoryColor !== variant.color;
    }
  }
  customElements.define('armadox-boot-story', ArmadoxBootStory);
})();
